import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import { RemoveRedEyeIcon, SearchIcon } from "../../../Resources/Icons/icons";
import moment from "moment";
import ReceivedDrawer from "./ReceivedDrawer";
import ReceivedDrawerFullPage from "./ReceivedDrawerFullPage";
import {
  GetPolicyList,
  GetPolicyFileById,
  GetCompany,
  GetLinkBookingCode,
  GetSubBookingCode,
  FilterPolicyList,
  ReframeEndDateTimeFormat,
} from "../../../Service/_index";
import Loader from "../../../UiComponents/Loader/Loader";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Divider, Stack, Badge } from "@mui/material";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import TabFilter from "../../Tabs/Tabs";
import Dialog from "@mui/material/Dialog";
import dayjs from "dayjs";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import file from "../../../Resources/Images/file.png";
import car from "../../../Resources/Images/car.png";
import tpCar from "../../../Resources/Images/tpCar.png";
import net from "../../../Resources/Images/net.png";
import total from "../../../Resources/Images/total.png";
import BulkUploadCommision from "./components/BulkUploadCommision";
import HistoryIcon from "@mui/icons-material/History";
import BulkUploadHistoryDialog from "../BulkUpload/BulkUploadHistoryDialog";

const getClassName = (data) => {
  return data.policyNumber ? "file_link" : "";
};

const headCells = [
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
    type: "date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "regNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "totalReceivable",
    placeMent: true,
    disablePadding: false,
    label: "Total Receivable",
    type: "amount",
  },
  {
    id: "receivedAmount",
    placeMent: true,
    disablePadding: false,
    label: "Received Amount",
    type: "amount",
  },
  {
    id: "pendingReceivable",
    placeMent: true,
    disablePadding: false,
    label: "Pending Receivable",
    type: "amount",
  },
  {
    id: "action",
    placeMent: true,
    disablePadding: false,
    label: "Action",
    type: "button",
    buttonLabel: "Received",
    buttonColor: "success",
    buttonClass: "Common_Button",
    altComponent: RemoveRedEyeIcon,
  },
  {
    id: "viewTransaction",
    placeMent: false,
    disablePadding: false,
    label: "View Transaction",
    type: "button",
    buttonLabel: "View Trans",
    buttonColor: "success",
    buttonClass: "Common_Button",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const ReceivableStatus = () => {
  const lastWeekDate = dayjs().subtract(7, "days").startOf("day");
  const todayDate = dayjs().startOf("day");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [showViewTrans, setShowViewTrans] = useState(false);
  const [totalReceivableAmount, setTotalReceivableAmount] = useState([]);
  const [totalReceivedAmount, setTotalReceivedAmount] = useState([]);
  const [pendingReceivableAmount, setPendingReceivableAmount] = useState([]);
  const [receivedButton, setReceivedButton] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(lastWeekDate);
  const [selectedEndDate, setSelectedEndDate] = useState(todayDate);
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const [openBulkUpload, setOpenBulkUpload] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);

  const [FilteredData, setFilteredData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [searchText, setSearchText] = useState("");
  const [queryParam, setQueryParam] = useState({
    page: 0,
    limit: 10,
    sort: "id",
    search: "",
  });
  const [tableConfig, setTableConfig] = useState({
    isAction: false,
    isView: false,
    isEdit: false,
    isDelete: false,
    isSearch: false,
    isApprove: false,
  });
  const [showFilter, setShowFilter] = useState(false);
  const [summaryData, setSummaryData] = useState({});
  const [searchTrigger, setSearchTrigger] = useState(0);

  const formatNumber = (num) => new Intl.NumberFormat("en-IN").format(num);

  const FilterOption = [
    {
      label: "Pending",
      type: "PendingFunction",
      value: 1,
      visibility: "block",
    },
    {
      label: "Received",
      type: "ReceivedFunction",
      value: 2,
      visibility: "block",
    },
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleTableOutputEvent = (params) => {
    setQueryParam({
      page: params.page,
      limit: params.limit,
      sort: params.sort,
      search: params.search || queryParam.search,
    });

    // Update the state variables that trigger the API call
    if (params.page !== undefined) {
      setPage(params.page - 1); // Convert to 0-based index
    }
    if (params.limit !== undefined) {
      setRowsPerPage(params.limit);
    }
    if (params.sortType !== undefined && params.sort !== undefined) {
      setOrder(params.sortType);

      // Extract the field name from the sort string properly
      let fieldName = params.sort;
      if (params.sort.startsWith("-")) {
        fieldName = params.sort.substring(1);
        setOrder("desc");
      } else {
        setOrder("asc");
      }
      setOrderBy(fieldName);
    }
  };
  const GetData = () => {
    GetPolicyList().then((res) => {
      const FilterPolicy = res.data.filter(
        (item) => item.isCommisionRecievable === true,
      );
      setFilteredData([]);
    });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = (res.data || [])
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const [selectedCompanyId, setSelectedCompanyId] = useState();
  const [bookingCodeValue, setBookingCodeValue] = useState();
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState();
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);

  const GetLinkBookingCodeDetails = () => {
    GetLinkBookingCode().then((res) => {
      const modifiedBookingCodeDetails = (res.data || [])
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              actual_id: e._id,
              _id: e.bookingCodeId._id,
              label: e.bookingCodeId.bookingCode,
              value: e.bookingCodeId._id,
            };
          }
          return null;
        })
        .filter(Boolean);
      // const modData = modifiedBookingCodeDetails.filter(
      //   (e) => e.companyId._id === selectedCompanyId,
      // );
      let uniqueObjectsMap = new Map();
      modifiedBookingCodeDetails.map((obj) => {
        uniqueObjectsMap.set(obj.bookingCodeId._id, obj);
      });
      let uniqueArray = Array.from(uniqueObjectsMap.values());
      setBookingCodeDetails(uniqueArray);
    });
  };

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCodeDetails = (res.data || [])
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const FilterSubBookingCodeDetails = modifiedSubBookingCodeDetails.filter(
        (item) => item.bookingCodeId === bookingCodeValue,
      );
      setSubBookingCodeDetails(FilterSubBookingCodeDetails);
    });
  };

  // React.useEffect(() => {
  //   GetCompanyDetails();
  // }, []);

  useEffect(() => {
    // if (selectedCompanyId) {
    GetLinkBookingCodeDetails();
    // }
  }, []);

  useEffect(() => {
    if (bookingCodeValue) {
      GetSubBookingCodeDetails();
    }
  }, [bookingCodeValue]);

  const ReceivedDrawerFunction = (row) => {
    setSelectedData(row);
    setOpenDrawer(true);
    setShowViewTrans(false);
  };

  const ViewTransFunction = (row) => {
    setSelectedData(row);
    setOpenDrawer(true);
    setShowViewTrans(true);
  };

  const calculateSum = (arr) => {
    if (!arr || arr.length === 0) return 0;
    return arr.reduce((total, current) => {
      return Number(total) + Number(current);
    }, 0);
  };

  useEffect(() => {
    // A Policy Number search is a separate, standalone lookup - it bypasses
    // the Pending/Received tab entirely and is only re-run when Search is hit
    // (searchTrigger), not on every keystroke.
    if (selectedPolicyNumber) {
      PolicySearchFunction();
    } else if (selectedTab === 1) {
      PendingFunction();
    } else {
      ReceivedFunction();
    }
  }, [
    page,
    rowsPerPage,
    selectedTab,
    searchText,
    orderBy,
    order,
    // selectedEndDate intentionally excluded - picking a date range must only
    // apply once the Search button is clicked (searchTrigger), same as every
    // other filter (Company, Booking Code, Policy Number).
    searchTrigger,
  ]);

  // Fast, standalone Policy Number search. Sends a minimal, separate payload
  // (just the policy number) so it bypasses company/booking-code/date/tab
  // filters entirely and hits the backend's indexed {clientId, policyNumber}
  // lookup directly, instead of the heavier combined Pending/Received query.
  const PolicySearchFunction = async () => {
    setOpenLoader(true);
    FilterPolicyList({
      policyNumber: selectedPolicyNumber.trim().toUpperCase(),
      FilterType: "UTILITES_SCREEN",
      screen: "RECEIVABLE_STATUS",
      isPaginationEnabled: true,
      limit: rowsPerPage,
      page: page + 1,
      skip: page * rowsPerPage,
      sort: { [orderBy]: order === "asc" ? 1 : -1 },
    })
      .then((res) => {
        setOpenLoader(false);
        const mappedData = (res.data || []).map((data) => ({
          _id: data?._id,
          policyDate: data?.issueDate,
          companyName: data?.companyId?.shortName,
          policyNumber: data?.policyNumber,
          customerName: data?.customerName,
          regNumber: data?.registrationNumber,
          totalReceivable: data?.commisionRecievable?.Total,
          receivedAmount: data?.commisionRecievable?.ReceivedAmount,
          pendingReceivable:
            data?.commisionRecievable?.PendingAmount ??
            data?.commisionRecievable?.Total,
          action: "",
          viewTransaction: "",
          data: data,
        }));
        setFilteredData(mappedData);
        setTotalCount(
          res.data[0]?.totalSummary?.totalRecord ?? mappedData.length,
        );
        setReceivedButton(selectedTab === 1);
        setSummaryData(res.data[0]?.totalSummary || {});
      })
      .catch((err) => {
        console.error("Error in PolicySearchFunction:", err);
        setOpenLoader(false);
      });
  };

  const ReceivedFunction = async () => {
    setOpenLoader(true);
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }

    const filterParams = {
      startDate: selectedStartDate,
      endDate: endDate,
      FilterType: "UTILITES_SCREEN",
      isPaginationEnabled: true,
      limit: rowsPerPage,
      page: page + 1,
      screen: "RECEIVABLE_STATUS",
      search: searchText,
      skip: page * rowsPerPage,
      sort: { [orderBy]: order === "asc" ? 1 : -1 },
      type: "RECEIVED",
      companyId: selectedCompany?._id || selectedCompany?.value,
      bookingCodeId: selectedBookingCode?._id || selectedBookingCode?.value,
      // subBookingCodeId: selectedSubBookingCode?._id || selectedSubBookingCode?.value,
    };

    // Remove empty parameters
    Object.keys(filterParams).forEach((key) => {
      if (
        filterParams[key] === null ||
        filterParams[key] === undefined ||
        filterParams[key] === ""
      ) {
        delete filterParams[key];
      }
    });

    FilterPolicyList(filterParams)
      .then((res) => {
        setOpenLoader(false);

        // FIXED: Use res.data directly instead of res.data.data
        const mappedData = (res.data || []).map((data) => ({
          _id: data?._id,
          policyDate: data?.issueDate,
          companyName: data?.companyId?.shortName,
          policyNumber: data?.policyNumber,
          customerName: data?.customerName,
          regNumber: data?.registrationNumber,
          totalReceivable: data?.commisionRecievable?.Total,
          receivedAmount: data?.commisionRecievable?.ReceivedAmount,
          pendingReceivable:
            data?.commisionRecievable?.PendingAmount ??
            data?.commisionRecievable?.Total,
          action: "",
          viewTransaction: "",
          data: data,
        }));
        setFilteredData(mappedData);

        // FIXED: Use res.totalRecord or res.data.length for total count
        setTotalCount(res.data[0]?.totalSummary?.totalRecord || 0);

        // FIXED: Use res.data directly
        const TotalReceivable = (res.data || []).map(
          (e) => e.commisionRecievable?.Total || 0,
        );
        setTotalReceivableAmount(TotalReceivable);
        setTotalReceivedAmount(["0"]);
        setPendingReceivableAmount(["0"]);
        setReceivedButton(false);
        setSummaryData(res.data[0]?.totalSummary || {});
      })
      .catch((err) => {
        console.error("Error in ReceivedFunction:", err);
        setOpenLoader(false);
      });
  };

  const PendingFunction = async () => {
    setOpenLoader(true);
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }

    // Validate orderBy to prevent empty string
    const validOrderBy =
      orderBy && orderBy.trim() !== "" ? orderBy : "policyDate"; // default field

    const filterParams = {
      startDate: selectedStartDate,
      endDate: endDate,
      FilterType: "UTILITES_SCREEN",
      isPaginationEnabled: true,
      limit: rowsPerPage,
      page: page + 1,
      screen: "RECEIVABLE_STATUS",
      search: searchText,
      skip: page * rowsPerPage,
      sort: { [validOrderBy]: order === "asc" ? 1 : -1 }, // Use validated orderBy
      type: "PENDING",
      companyId: selectedCompany?._id || selectedCompany,
      bookingCodeId: selectedBookingCode?._id || selectedBookingCode,
      // subBookingCodeId: selectedSubBookingCode?._id || selectedSubBookingCode,
    };

    // Remove empty parameters
    Object.keys(filterParams).forEach((key) => {
      if (
        filterParams[key] === null ||
        filterParams[key] === undefined ||
        filterParams[key] === ""
      ) {
        delete filterParams[key];
      }
    });

    FilterPolicyList(filterParams)
      .then((res) => {
        setOpenLoader(false);
        const mappedData = (res.data || []).map((data) => ({
          _id: data?._id,
          policyDate: data?.issueDate,
          companyName: data?.companyId?.shortName,
          policyNumber: data?.policyNumber,
          customerName: data?.customerName,
          regNumber: data?.registrationNumber,
          totalReceivable: data?.commisionRecievable?.Total,
          receivedAmount: data?.commisionRecievable?.ReceivedAmount,
          pendingReceivable:
            data?.commisionRecievable?.PendingAmount ??
            data?.commisionRecievable?.Total,
          action: "",
          viewTransaction: "",
          data: data,
        }));
        setFilteredData(mappedData);
        setTotalCount(res.data[0]?.totalSummary?.totalRecord || 0);

        const TotalReceivable = (res.data || []).map(
          (e) => e.commisionRecievable?.Total || 0,
        );
        const totalReceived = (res.data || []).map(
          (e) => e.commisionRecievable?.ReceivedAmount || 0,
        );
        const totalPending = (res.data || []).map(
          (e) => e.commisionRecievable?.PendingAmount || 0,
        );

        setTotalReceivableAmount(TotalReceivable);
        setTotalReceivedAmount(totalReceived);
        setPendingReceivableAmount(totalPending);
        setReceivedButton(true);
        setSummaryData(res.data[0]?.totalSummary || {});
      })
      .catch((err) => {
        console.error("Error in PendingFunction:", err);
        setOpenLoader(false);
      });
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          `<embed src="${blobUrl}" width="100%" height="100%" />`,
        );
      });
  };

  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const implementCond = (cell) => {
    return cell.map((obj) =>
      obj.id === "action"
        ? {
            ...obj,
            condition: (row) => receivedButton,
          }
        : obj.id === "viewTransaction"
          ? {
              ...obj,
              condition: (row) => true,
            }
          : obj,
    );
  };

  // Clearing filters (single or all) only resets the local filter state - it
  // must NOT re-fetch. The new (empty) filters only take effect once the user
  // explicitly clicks Search, same as picking a filter value.
  const handleClearAllState = () => {
    setSelectedBookingCode(null);
    setSelectedCompany(null);
    setSelectedCompanyId(null);
    setSelectedSubBookingCode(null);
    setBookingCodeValue(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setSelectedPolicyNumber("");
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedCompany(null);
      setSelectedCompanyId(null);
    } else if (filterId === 2) {
      setSelectedBookingCode(null);
      setBookingCodeValue(null);
      // Also clear sub booking code when booking code is cleared
      setSelectedSubBookingCode(null);
    } else if (filterId === 3) {
      setSelectedSubBookingCode(null);
    } else if (filterId === 4) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    } else if (filterId === 5) {
      setSelectedPolicyNumber("");
    }
  };

  const handleSaveAllFilter = () => {
    setPage(0);
    setSearchTrigger((prev) => prev + 1);
  };

  const filterBoxData = [
    // {
    //   id: 1,
    //   label: "Select Company",
    //   data: companyDetails,

    //   setState: (v) => {
    //     setSelectedCompany(v);
    //     setSelectedCompanyId(v || v?._id);
    //   },
    //   value: selectedCompany,
    //   type: "input",
    //   variation: "single",
    // },
    {
      id: 2,
      label: "Booking Code",
      data: bookingCodeDetails,
      value: selectedBookingCode,
      setState: (v) => {
        setSelectedBookingCode(v);
        setBookingCodeValue(v || v?._id);
      },
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "SubBooking Code",
      data: subBookingCodeDetails,
      value: selectedSubBookingCode,
      setState: (v) => {
        setSelectedSubBookingCode(v);
      },
      type: "input",
      variation: "single",
    },
    {
      id: 4,
      label: "Start Date & End Date",
      setDate: (e) => {
        setSelectedStartDate(e ? e[0] : null);
        setSelectedEndDate(e ? e[1] : null);
      },
      type: "noDefaultDate",
      // defaultValue: [dayjs().subtract(7, "day"), dayjs()],
      // value: [selectedStartDate, selectedEndDate],
      defaultValue:
        selectedStartDate && selectedEndDate
          ? [selectedStartDate, selectedEndDate]
          : null,
    },
    {
      id: 5,
      label: "Policy Number",
      setState: setSelectedPolicyNumber,
      value: selectedPolicyNumber,
      type: "normalInput",
    },
  ];

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            {/* Summary Cards Section */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                mb: 3,
              }}
            >
              {[
                {
                  label: "Policy Count",
                  value: totalCount,
                  image: file,
                  color: "#EFF6FF",
                },
                {
                  label: "Total Premium",
                  value: summaryData?.totalReceivableAmount,
                  image: car,
                  color: "#F0FDF4",
                },
                {
                  label: "Total Received Amt",
                  value: summaryData?.totalReceivedAmount,
                  image: tpCar,
                  color: "#FEF3C7",
                },
                {
                  label: "Pending Receivable",
                  value: summaryData?.pendingReceivableAmount,
                  image: net,
                  color: "#F3E8FF",
                },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: {
                      xs: "1 1 100%",
                      sm: "1 1 calc(50% - 16px)",
                      md: "1 1 calc(25% - 16px)",
                    },
                    minWidth: {
                      xs: "100%",
                      sm: "calc(50% - 16px)",
                      md: "calc(25% - 16px)",
                    },
                    backgroundColor: "#fff",
                    border: "1px solid #E4E7EC",
                    borderRadius: "8px",
                    padding: "16px",
                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
                      transform: "translateY(-2px)",
                    },
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      flex: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: item?.color || "#F0F9FF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src={item?.image}
                        alt={item?.label}
                        style={{ width: "20px", height: "20px" }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "12px",
                        color: "#667085",
                        fontFamily: "Inter",
                      }}
                    >
                      {item?.label}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "24px",
                      color: "#1D2939",
                      fontFamily: "Inter",
                      lineHeight: 1.2,
                      flexShrink: 0,
                    }}
                  >
                    {item.value ? formatNumber(item.value) : 0}
                  </Typography>
                </Box>
              ))}
            </Box>
            <Grid container className="Master_Card_Container">
              {/* Header Section */}
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Commision Receivable Approval
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ height: "40px", gap: "8px" }}
                        startIcon={<CloudUploadIcon />}
                        onClick={() => setOpenBulkUpload(true)}
                      >
                        Bulk Upload
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ height: "40px", gap: "8px" }}
                        startIcon={<HistoryIcon />}
                        onClick={() => setHistoryOpen(true)}
                      >
                        Uploaded Files
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={
                              [
                                selectedCompany,
                                selectedBookingCode,
                                selectedSubBookingCode,
                                selectedPolicyNumber,
                              ].filter(Boolean).length +
                              (selectedStartDate && selectedEndDate ? 1 : 0)
                            }
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                    sx={{
                      "& .filter-box-container": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                      "& .MuiPaper-root": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                    }}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              {/* Tab, Summary and Search Section */}
              <Grid
                container
                direction="row"
                sx={{ justifyContent: "flex-end", alignItems: "center" }}
                className="Master_Card_Sub_Container"
              >
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {/* Policy Count and Amounts */}
                  {/* Policy Count and Amounts */}
                  <Grid item xs={12} sm={8} md={9}>
                    <Grid container spacing={4} alignItems="center">
                      <TabFilter
                        options={FilterOption}
                        selectedTab={selectedTab}
                        onTabChange={handleTabChange}
                      />
                    </Grid>
                  </Grid>

                  {/* Search Input */}
                  <Grid item xs={12} sm={4} md={3}>
                    <Input
                      className="w-100 Master_Card_Input"
                      id="standard-adornment-password"
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setPage(0);
                      }}
                      disableUnderline
                      placeholder="Search in Access"
                      startAdornment={
                        <InputAdornment position="start">
                          <IconButton>
                            <SearchIcon sx={{ fontSize: "20px" }} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Table */}
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                columns={implementCond(headCells)}
                handleOnClickBehaviour={OpenPolicyFile}
                handleButton={{
                  "View Trans": ViewTransFunction,
                  Received: ReceivedDrawerFunction,
                }}
                tableTotalCount={totalCount}
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                isServerSide={true}
                tableOutputEvent={handleTableOutputEvent}
                paginationReset={selectedTab + searchText + searchTrigger}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>

      {showViewTrans ? (
        <Drawer
          open={openDrawer}
          sx={{
            zIndex: 100,
          }}
          anchor="right"
          PaperProps={{
            sx: { width: { xs: "100%", sm: showViewTrans ? "100%" : "25%" } },
          }}
        >
          {openDrawer ? (
            <ReceivedDrawerFullPage
              setOpenDrawer={setOpenDrawer}
              selectedData={selectedData.data}
              formType={selectedData?._id ? "edit" : "add"}
              showViewTrans={showViewTrans}
              GetData={GetData}
              PendingFunction={PendingFunction}
            />
          ) : null}
        </Drawer>
      ) : (
        <Dialog
          open={openDrawer}
          sx={{
            zIndex: 100,
          }}
          anchor="right"
          PaperProps={{
            sx: { width: { xs: "100%", sm: showViewTrans ? "100%" : "25%" } },
          }}
        >
          {openDrawer ? (
            <ReceivedDrawer
              setOpenDrawer={setOpenDrawer}
              selectedData={selectedData.data}
              formType={selectedData?._id ? "edit" : "add"}
              showViewTrans={showViewTrans}
              GetData={GetData}
              PendingFunction={PendingFunction}
            />
          ) : null}
        </Dialog>
      )}
      {/* <Loader open={openLoader} /> */}
      <BulkUploadCommision
        open={openBulkUpload}
        setOpen={setOpenBulkUpload}
        onSuccess={() => setSearchTrigger((prev) => prev + 1)}
      />
      <BulkUploadHistoryDialog
        open={historyOpen}
        setOpen={setHistoryOpen}
        defaultType="CommisionReceived"
        title="Commision Received — Bulk Upload History"
      />
    </>
  );
};
export default ReceivableStatus;
